import bg_home from 'assets/images/bg_home.jpg';
import HeaderMenu from 'components/Header/HeaderMenu';
import { PredictionHistoryPanel, WorldCupHistoryResultsPanel } from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getFP, getIP } from 'service/base';
import { twMerge } from 'tailwind-merge';

const RESULT_TABS = [
  { key: 'score', label: 'DỰ ĐOÁN TỶ SỐ' },
  { key: 'worldcup', label: 'DỰ ĐOÁN WORLD CUP' }
];

const PrizeStructure = () => {
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [resultTab, setResultTab] = useState('score');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const ipRes = await getIP();
        const fpRes = await getFP();
        if (cancelled) return;
        setIP(ipRes);
        setFP(fpRes);
      } catch {
        if (!cancelled) {
          setIP(null);
          setFP(null);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home}
        alt="Background"
        className="h-full w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative z-10 max-w-[1000px] mx-auto px-2 pt-2 md:pt-4">
          <div
            className="rounded-2xl border-2 border-[#A6CAFA] bg-white/75 backdrop-blur-md shadow-[0_8px_40px_rgba(0,83,223,0.12)] px-3 py-4 md:px-6 md:py-6"
            style={{ boxShadow: '0 4px 24px rgba(17,73,160,0.12), inset 0 0 0 1px rgba(255,255,255,0.8)' }}
          >
            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-5 px-1">
              {RESULT_TABS.map((tab) => {
                const active = resultTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setResultTab(tab.key)}
                    className={twMerge(
                      'rounded-[50px] px-4 md:px-8 py-2 md:py-2.5 text-[10px] sm:text-[11px] md:text-[13px] font-extrabold uppercase tracking-[0.02em] border-2 transition-all duration-200',
                      active
                        ? 'border-[#0053DF] bg-[#0053DF] text-white shadow-[0_3px_10px_rgba(0,83,223,0.35)]'
                        : 'border-[#D9E2EF] bg-white text-[#1E56C7] hover:border-[#A6CAFA]'
                    )}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            {resultTab === 'score' ? (
              <PredictionHistoryPanel IP={IP} FP={FP} />
            ) : (
              <WorldCupHistoryResultsPanel />
            )}
          </div>
        </div>
      </div>{' '}
    </div>
  );
};

export default PrizeStructure;
